<template>
  <div>
    <b v-if="proc">Processo:</b> {{ proc }}
    <b v-if="classe?.descricao">Classe:</b> {{ classe?.descricao }}
    <br/>
    <b v-if="procstj">Processo STJ:</b> {{ procstj }}
    <b v-if="sitstj">Situação STJ:</b> {{ sitstj }}
    <br/>
    <b v-if="procstf">Processo STF:</b> {{ procstf }}
    <b v-if="sitstf">Situação STF:</b> {{ sitstf }}

  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { useClasseJudicialStore } from "@/store/classe-store";

const classeStore = useClasseJudicialStore();
classeStore.fetch();

const props = defineProps({ modelValue: {} });

const proc = computed(() => props.modelValue.numero);
const procstj = computed(() => props.modelValue.numeroProcessoSTJ);
const sitstj = computed(() => props.modelValue.situacaoSTJ);
const procstf = computed(() => props.modelValue.numeroProcessoSTF);
const sitstf = computed(() => props.modelValue.situacaoSTF);

const classe = computed(() =>
    classeStore.all.find(c => c.id == props.modelValue.classe)
);

</script>
